<template>
	<v-row class="pb-4">
		<v-col cols="12" class="border-container">
			<v-row class="py-3">
				<v-col cols="8">
					<v-row>
						<v-col cols="6" class="font-weight-medium header-color">{{ $t('selectortickettype.tickettype') }}</v-col>
						<v-col cols="6" class="font-weight-medium header-color">{{ $t('selectortickettype.validityanddetails') }}</v-col>
					</v-row>
				</v-col>
				<v-col cols="4" class="font-weight-medium header-color d-flex justify-end">
					<v-row class="d-flex justify-end">
						<v-col :cols="12" :md="8" :lg="6">{{ $t('selectortickettype.quantity') }} </v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>

		<v-col cols="12" class="border-container" v-for="(configuration, index) in getTicketConfigurations" :key="index">
			<selector-ticket-type-row :id="'ticket-' + configuration.id" :configuration="configuration" />
		</v-col>
	</v-row>
</template>

<script>
import SelectorTicketTypeRow from './SelectorTicketTypeRow';
import { mapGetters, mapActions } from 'vuex';

export default {
	components: { 'selector-ticket-type-row': SelectorTicketTypeRow },
	data: () => ({}),
	methods: {
		...mapActions(['EMPTY_ALL_SELECTED_TICKETS'])
	},
	computed: {
		...mapGetters(['getTicketConfigurations', 'getTicketsToSale'])
	},
	mounted() {
		//para develop
		//si se recarga el componente reinicia los tickets seleccionados...
	}
};
</script>

<style scoped>
.border-container {
	border-bottom: 0.5px solid #d2d7d9;
}

.header-color {
	color: #868c8d;
}
</style>
